import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
// Import Constants
import l from 'constants/localizationLabels';
import { BUTTON_ROWS_FORM_KEY } from './constants';

export const useButtonBuilderValidation = () => {
    const { t } = useTranslation();

    return Yup.object({
        [BUTTON_ROWS_FORM_KEY]: Yup.array().of(
            Yup.array().of(
                Yup.object().shape({
                    url: Yup.string()
                        .url(t(l.EnterValidUrl))
                        .required(t(l.CannotBeEmpty, { fieldName: t(l.ButtonUrl) })),
                    text: Yup.string()
                        .max(30, t(l.MustContainMaximumCharacters, { fieldName: t(l.ButtonText), count: 30 }))
                        .required(t(l.CannotBeEmpty, { fieldName: t(l.ButtonText) })),
                }),
            ),
        ),
    });
};
